var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCompany(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 41,
    viewBox: "0 0 36 41",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-982.000000, -332.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(330.000000, 302.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(652.000000, 30.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#00A0CE",
    x: 0,
    y: 0,
    width: 36,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#00A0CE",
    x: 11,
    y: 10,
    width: 5,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#00A0CE",
    x: 20,
    y: 20,
    width: 5,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#00A0CE",
    x: 20,
    y: 10,
    width: 5,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#00A0CE",
    x: 11,
    y: 20,
    width: 5,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#00A0CE",
    strokeWidth: 2,
    x: 5,
    y: 2,
    width: 26,
    height: 38
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#00A0CE",
    strokeWidth: 2,
    x: 14,
    y: 32,
    width: 8,
    height: 8
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany);
export default __webpack_public_path__ + "static/media/company.286ea63c93ad62e47a189c5a1d618ec1.svg";
export { ForwardRef as ReactComponent };